/** Provides constants for node data attributes.
Not to be confused with the Node.js JavaScript runtime.*/
export const NODE = {
	ID: "id",
	LABEL: "l",
	LABEL_GERMAN: "de",
	LABEL_ENGLISH: "en",
	LABEL_PERSIAN: "fa",
	SUBTOP: "st",
	SOURCE: "source",
	HAS_INSTANCE: "inst", // whether this class has at least once instance
	SUBTOP_ENTITY_TYPE: "E",
	SUBTOP_ROLE: "R",
	SUBTOP_FUNCTION: "F",
	TYPE: "t",
};
